import React, {Component} from 'react';
import {Button, ControlLabel, FormControl, FormGroup, Modal} from 'react-bootstrap';
import ErrorMessageContainer from './ErrorMessageContainer';
import axios from 'axios';
import DecimalHelpBlock from "./DecimalHelpBlock";
import Utils from "./Utils";

export default class FrameworkContractsAddArticleModal extends Component {
    constructor() {
        super();

        this.state = {
            validationErrors: [],
            submitDisabled: false,
            title: "",
            amount: "",
            amount_vat: "",
        };

        this.submit = this.submit.bind(this);
        this.close = this.close.bind(this);
        this.handleTitleChange = this.handleTitleChange.bind(this);
        this.handleAmountChange = this.handleAmountChange.bind(this);
        this.handleAmountVatChange = this.handleAmountVatChange.bind(this);
    }

    componentWillReceiveProps(nextProps) {
        this.setState({
            validationErrors: [],
            submitDisabled: false,
            title: "",
            amount: "",
            amount_vat: "",
        });
    }

    submit() {
        if (!this.state.submitDisabled) {
            this.setState({
                validationErrors: [],
                submitDisabled: true
            }, () => {
                let url = "/contracts/ajax/framework_contracts/" + this.props.id + "/add_article";

                axios
                    .post(url, {
                        title: this.state.title,
                        amount: this.state.amount,
                        amount_vat: this.state.amount_vat,
                    })
                    .then((response) => {
                        this.setState({
                            submitDisabled: false
                        }, () => {
                            this.close();
                        });

                        if (response.data === "ok")
                            location.reload();
                    })
                    .catch((failure) => {
                        this.setState({
                            validationErrors: failure.response.data,
                            submitDisabled: false
                        });
                    });
            });
        }
    }

    close() {
        this.props.closeCallback();
    }

    handleAmountChange(e) {
        let value = Utils.handleDecimals(e.target.value);
        let amount = parseFloat(e.target.value.replace(",", "."));
        let amount_vat = Utils.calculateAmountVATFromAmount("24", amount);
        this.setState({
            amount: value,
            amount_vat: amount_vat,
        });
    }

    handleAmountVatChange(e) {
        let value = Utils.handleDecimals(e.target.value);
        let amount_vat = parseFloat(e.target.value.replace(",", "."));
        let amount = Utils.calculateAmountFromAmountVAT("24", amount_vat);
        this.setState({
            amount: amount,
            amount_vat: value,
        });
    }

    handleTitleChange(e) {
        this.setState({title: e.target.value});
    }

    render() {
        return (
            <Modal show={this.props.showModal} onHide={this.close}>
                <Modal.Header closeButton>
                    <Modal.Title>{window.__js_contracts.framework_contract_article_add}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <ErrorMessageContainer errors={this.state.validationErrors}/>

                    <FormGroup controlId="article_title">
                        <ControlLabel>{window.__js_contracts.title}*</ControlLabel>
                        <FormControl type="text"
                                     value={this.state.title}
                                     name="article_title"
                                     id="article_title"
                                     onChange={this.handleTitleChange}/>
                    </FormGroup>

                    <FormGroup controlId="article_amount">
                        <ControlLabel>{window.__js_contracts.amount}*</ControlLabel>
                        <FormControl type="text"
                                     value={this.state.amount}
                                     name="article_amount"
                                     id="article_amount"
                                     onChange={this.handleAmountChange}/>
                        <DecimalHelpBlock/>
                    </FormGroup>

                    <FormGroup controlId="article_amount_vat">
                        <ControlLabel>{window.__js_contracts.amount_with_vat}*</ControlLabel>
                        <FormControl type="text"
                                     value={this.state.amount_vat}
                                     name="article_amount_vat"
                                     id="article_amount_vat"
                                     onChange={this.handleAmountVatChange}/>
                        <DecimalHelpBlock/>
                    </FormGroup>
                </Modal.Body>
                <Modal.Footer>
                    <Button onClick={this.submit}
                            bsStyle="primary"
                            disabled={this.state.submitDisabled}>{window.__js_general.save}</Button>
                    <Button onClick={this.close}>{window.__js_general.close}</Button>
                </Modal.Footer>
            </Modal>
        );
    }
}